import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { useField } from 'react-final-form';
import * as R from 'ramda';

import useFormPropertyScroll from 'hooks/useFormPropertyScroll';

import Property from 'components/blocks/Property';
import { FormBox, NarrowFormFlex } from 'components/shared/form';

const propTypes = {
  activeName: PropTypes.string,
  canDelete: PropTypes.bool,
  canSwap: PropTypes.bool,
  children: PropTypes.node.isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({})),
  name: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  toClose: PropTypes.func.isRequired,
  toOpen: PropTypes.func.isRequired,
  toToggle: PropTypes.func.isRequired,
  render: PropTypes.func,
};

const defaultProps = {
  activeName: null,
  canDelete: false,
  canSwap: false,
  details: [],
  render: undefined,
};

function FormProperty({
  activeName,
  canDelete,
  canSwap,
  children,
  details,
  name,
  onDelete,
  render,
  toClose,
  toOpen,
  toToggle,
}) {
  const isOpen = R.equals(name, activeName);

  const {
    el,
    toToggleProperty,
    toOpenProperty,
  } = useFormPropertyScroll({ name, toOpen, toToggle, isOpen });

  const propertyField = useField(name);
  const property = R.pathOr({}, ['input', 'value'], propertyField);
  const isHidden = R.prop('_hidden', property);
  const isInvalid = R.path(['meta', 'invalid'], propertyField);

  if (isHidden) return null;

  return (
    <div ref={el}>
      <NarrowFormFlex key={name}>
        <FormBox pl={0} pr={0} mb="1.25rem" width={1}>
          <StyledProperty
            colorScheme="white"
            canDelete={canDelete}
            canSwap={canSwap}
            details={details}
            isInvalid={isInvalid}
            isOpen={isOpen}
            onDelete={() => onDelete(name)}
            property={property}
            toClose={() => toClose(name)}
            toOpen={toOpenProperty}
            toToggle={toToggleProperty}
            render={render}
          >
            {children}
          </StyledProperty>
        </FormBox>
      </NarrowFormFlex>
    </div>
  );
}

const StyledProperty = styled(Property)`
  ${({ isOpen }) =>
    !isOpen &&
    css`
      margin-right: 0.625rem;
      margin-left: 0.625rem;
    `}
`;

FormProperty.propTypes = propTypes;
FormProperty.defaultProps = defaultProps;

export default FormProperty;
